module.exports = __webpack_public_path__ + "img/001.0ccc7377.jpg";